import { createTheme, globalTheme } from '@cld/component-theme';

const { palette } = globalTheme;

export const appsTheme = createTheme({
  xxl: {
    size: '2.25rem',
    lineHeight: '2.5rem',
    contrastInvert: {
      color: palette.contrastInvert,
      weight: '700',
    },
    regular: {
      color: palette.contrastHigh,
      weight: '700',
    },
    overlay: {
      color: palette.overlayLight,
      weight: '700',
    },
    overlayInvert: {
      color: palette.overlayDark,
      weight: '700',
    },
  },
  xl: {
    size: '1.5rem',
    lineHeight: '1.625rem',
    contrastInvert: {
      color: palette.contrastInvert,
      weight: '500',
    },
    regular: {
      color: palette.contrastHigh,
      weight: '500',
    },
    overlay: {
      color: palette.overlayLight,
      weight: '500',
    },
    overlayInvert: {
      color: palette.overlayDark,
      weight: '500',
    },
  },
  lg: {
    size: '1.125rem',
    lineHeight: '1.375rem',
    highContrast: {
      color: palette.contrastHigh,
      weight: '500',
    },
    lowContrast: {
      color: palette.contrastHigh,
      weight: '300',
    },
    url: {
      color: palette.primary,
      weight: '500',
    },
    contrastInvert: {
      color: palette.contrastInvert,
      weight: '500',
    },
    regular: {
      color: palette.contrastHigh,
      weight: '500',
    },
    overlay: {
      color: palette.overlayLight,
      weight: '500',
    },
    overlayInvert: {
      color: palette.overlayDark,
      weight: '500',
    },
  },
  md: {
    size: '1rem',
    lineHeight: '1.25rem',
    highContrast: {
      color: palette.contrastHigh,
      weight: '500',
    },
    lowContrast: {
      color: palette.contrastHigh,
      weight: '300',
    },
    regular: {
      color: palette.contrastHigh,
      weight: 'normal',
    },
    url: {
      color: palette.primary,
      weight: '500',
    },
    contrastInvert: {
      color: palette.contrastInvert,
      weight: '500',
    },
    error: {
      color: palette.errorAlt,
      weight: '500',
    },
    warning: {
      color: palette.warningAlt,
      weight: '500',
    },
    success: {
      color: palette.successAlt,
      weight: '500',
    },
    overlay: {
      color: palette.overlayLight,
      weight: '500',
    },
    overlayInvert: {
      color: palette.overlayDark,
      weight: '500',
    },
  },
  sm: {
    size: '0.875rem',
    lineHeight: '1.125rem',
    highContrast: {
      color: palette.contrastHigh,
      weight: '500',
    },
    regular: {
      color: palette.contrastHigh,
      weight: '400',
    },
    lowContrast: {
      color: palette.contrastHigh,
      weight: '300',
    },
    url: {
      color: palette.primary,
      weight: '500',
    },
    success: {
      color: palette.successAlt,
      weight: '500',
    },
    warning: {
      color: palette.warningAlt,
      weight: '500',
    },
    error: {
      color: palette.errorAlt,
      weight: '500',
    },
    contrastInvert: {
      color: palette.contrastInvert,
      weight: '500',
    },
    overlay: {
      color: palette.overlayLight,
      weight: '500',
    },
    overlayInvert: {
      color: palette.overlayDark,
      weight: '500',
    },
  },
  xs: {
    size: '0.75rem',
    lineHeight: '1rem',
    highContrast: {
      color: palette.contrastHigh,
      weight: '600',
    },
    regular: {
      color: palette.contrastHigh,
      weight: '400',
    },
    lowContrast: {
      color: palette.contrastHigh,
      weight: '300',
    },
    disabled: {
      color: palette.secondaryAlt,
      weight: '400',
    },
    url: {
      color: palette.primary,
      weight: '500',
    },
    success: {
      color: palette.successAlt,
      weight: '500',
    },
    warning: {
      color: palette.warningAlt,
      weight: '500',
    },
    error: {
      color: palette.errorAlt,
      weight: '500',
    },
    contrastInvert: {
      color: palette.contrastInvert,
      weight: '600',
    },
    overlay: {
      color: palette.overlayLight,
      weight: '500',
    },
    overlayInvert: {
      color: palette.overlayDark,
      weight: '500',
    },
  },
  xxs: {
    size: '0.625rem',
    lineHeight: '0.875rem',
    highContrast: {
      color: palette.contrastHigh,
      weight: '500',
    },
    lowContrast: {
      color: palette.contrastHigh,
      weight: '300',
    },
    regular: {
      color: palette.contrastHigh,
      weight: '400',
    },
    disabled: {
      color: palette.secondaryAlt,
      weight: '400',
    },
    url: {
      color: palette.primary,
      weight: '500',
    },
    success: {
      color: palette.successAlt,
      weight: '500',
    },
    warning: {
      color: palette.warningAlt,
      weight: '500',
    },
    error: {
      color: palette.errorAlt,
      weight: '500',
    },
    contrastInvert: {
      color: palette.contrastInvert,
      weight: '500',
    },
    overlay: {
      color: palette.overlayLight,
      weight: '500',
    },
    overlayInvert: {
      color: palette.overlayDark,
      weight: '500',
    },
  },
});
